export default "__VITE_ASSET__72108b75__"